export function changeCurrentTheme(currentTheme) {
  return {
    type: '@theme/SET_CURRENT_THEME',
    payload: { currentTheme },
  }
}

export function changeCurrentThemeSelected(currentThemeSelected) {
  return {
    type: '@theme/SET_CURRENT_THEME_SELECTED',
    payload: { currentThemeSelected },
  }
}
